// extracted by mini-css-extract-plugin
export default {"wrap":"AttachmentDisplay_wrap__8Chdf","attachmentFrame":"AttachmentDisplay_attachmentFrame__gjPaZ"};